/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

// src/components/ContextMenu/FirmalarContextMenu.js
import React, { useRef } from "react";
import { Box, Text, Flex, Icon, HStack } from "@chakra-ui/react";
import { FiUsers } from "react-icons/fi";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function FirmalarContextMenu({
  position,
  data,
  userRole,
  onClose,
  onOpenFirmaDetay,
  onAracEkle,
  onFaturaGecmisi,
  onNotEkle,
  onHatirlatmaGonder,
  onFirmaPasiflestir,
  onFirmaAktiflestir,
  onDegisiklikGecmisi,
  onHesapIslemleri,
  onOpenUetds,
}) {
  const timeoutRef = useRef(null);

  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 230, menuHeight: 320 });

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => onClose(), 50);
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
      minW="160px"
      fontSize="11px"
      py={1}
    >
      <MenuItem 
        label="Firma Detayları" 
        onClick={() => { 
          onOpenFirmaDetay?.(data); 
          onClose(); 
        }} 
      />
      
      <MenuItem
        label="Hesap İşlemleri"
        icon={FiUsers}
        onClick={() => {
          onHesapIslemleri?.(data);
          onClose();
        }}
      />

      {userRole === "admin" && (
        <MenuItem
          label="UETDS ayarları"
          onClick={() => {
            onOpenUetds?.(data);
            onClose();
          }}
        />
      )}
      
      <MenuItem 
        label="Araç Ekle" 
        onClick={() => { 
          onAracEkle?.(data); 
          onClose(); 
        }} 
      />
      
      <MenuItem 
        label="Fatura Geçmişi" 
        onClick={() => { 
          onFaturaGecmisi?.(data); 
          onClose(); 
        }} 
      />
      
      <MenuItem 
        label="Not Ekle" 
        onClick={() => { 
          onNotEkle?.(data); 
          onClose(); 
        }} 
      />
      <MenuItem
        label="Hatırlatma Gönder"
        onClick={() => {
          onHatirlatmaGonder?.(data);
          onClose();
        }}
      />
      
      <MenuItem 
        label="Değişiklik Geçmişi" 
        onClick={() => { 
          onDegisiklikGecmisi?.(data); 
          onClose(); 
        }} 
      />
      {String(data?.firma_durumu || "").toLowerCase().startsWith("pasif") ? (
        <MenuItem 
          label="Firma Aktifleştir" 
          onClick={() => { 
            onFirmaAktiflestir?.(data); 
            onClose(); 
          }} 
        />
      ) : (
        <MenuItem 
          label="Firma Pasifleştir" 
          isDestructive 
          onClick={() => { 
            onFirmaPasiflestir?.(data); 
            onClose(); 
          }} 
        />
      )}
    </Box>
  );
}

function MenuItem({ label, onClick, isDestructive = false, icon }) {
  return (
    <Flex
      align="center"
      justify="space-between"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: isDestructive ? "red.50" : "gray.50",
        color: isDestructive ? "red.600" : "gray.900",
        transform: "scale(1.02)"
      }}
      onClick={onClick}
    >
      <HStack spacing={2}>
        {icon && <Icon as={icon} size={12} />}
        <Text 
          fontWeight="500" 
          color={isDestructive ? "red.500" : "gray.600"}
          fontSize="11px"
        >
          {label}
        </Text>
      </HStack>
    </Flex>
  );
}

export default FirmalarContextMenu;
